import { render } from "./TvmVDVIcon.vue?vue&type=template&id=14b9153d"
import script from "./TvmVDVIcon.vue?vue&type=script&lang=js"
export * from "./TvmVDVIcon.vue?vue&type=script&lang=js"

import "./TvmVDVIcon.vue?vue&type=style&index=0&id=14b9153d&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__